// Default
export const courgerie = {
  logo_image_url: 'courgerie/default.png',
  logo_height: 115,
  token_url: 'courgerie/default.png',
  token_width: 70,
  number_hidden: true,
  button_color: '#ef7623',
  button_half_border_color: '#ef7623',
  text_font: `'Source Sans Pro', sans-serif`,
  title_font: `'Source Sans Pro', sans-serif`,
}

// Rouge Canneberge
export const rougecanneberge = {
  ...courgerie,
  logo_image_url: 'courgerie/rouge-canneberge.png',
  logo_height: 107,
  token_url: 'courgerie/rouge-canneberge.png',
}
